import React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import { useStyles as useParentStyles } from "client/domain/OnboardingStatus";
import { useTranslation } from "client/hooks";

import { StatusStep } from "../../StatusStep";

import { Step } from "./components/Step";
import { useStyles } from "./styles";

const useLocalStyles = makeStyles((theme: Theme) => ({
  skeleton: {
    borderRadius: 8,
    transform: "scale(1, 0.8)",
  },
  wrapper: {
    marginLeft: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
}));

export const IntegrationSkeleton: React.FC = () => {
  const classes = useStyles();
  const localClasses = useLocalStyles();
  const parentClasses = useParentStyles();
  const t = useTranslation();
  return (
    <StatusStep timeToFade={750}>
      <Box
        className={`${parentClasses.light} ${parentClasses.statusWrapper}`}
        mb={2}
        p={2}
      >
        <Box
          alignItems="center"
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <Typography variant="h6">
            <strong>{t("uiAddAfterpayToCheckout")}</strong>
          </Typography>
        </Box>
        <Step
          containerProps={{
            className: localClasses.wrapper,
          }}
          isActive={true}
          isComplete={false}
        >
          <Skeleton
            classes={{
              root: localClasses.skeleton,
            }}
            height={30}
            variant="text"
            width="60%"
          />
          <Skeleton
            classes={{
              root: localClasses.skeleton,
            }}
            height={60}
            variant="text"
            width="60%"
          />
        </Step>
        <Step
          containerProps={{
            className: localClasses.wrapper,
          }}
          isActive={false}
          isComplete={false}
        >
          <Box mb={1}>
            <Skeleton
              classes={{
                root: localClasses.skeleton,
              }}
              height={30}
              variant="text"
              width="75%"
            />
          </Box>
          <Box mb={2}>
            <Skeleton
              classes={{
                root: localClasses.skeleton,
              }}
              height={60}
              variant="text"
              width="75%"
            />
            <Skeleton
              classes={{
                root: localClasses.skeleton,
              }}
              height={60}
              variant="text"
              width="75%"
            />
          </Box>
          <Skeleton
            classes={{
              root: localClasses.skeleton,
            }}
            height={60}
            variant="text"
            width="90%"
          />
        </Step>
        <Step
          containerProps={{
            className: `${classes.lastStep} ${localClasses.wrapper}`,
          }}
          isActive={false}
          isComplete={false}
        >
          <Skeleton
            classes={{
              root: localClasses.skeleton,
            }}
            height={30}
            variant="text"
            width="60%"
          />
          <Skeleton
            classes={{
              root: localClasses.skeleton,
            }}
            height={60}
            variant="text"
            width="60%"
          />
        </Step>
      </Box>
    </StatusStep>
  );
};
